import React from "react";
import { Table, Typography } from "antd";

const { Title } = Typography;

const empty = "\u00A0";

const Section3_2 = ({ printMode = false }) => {
  const data = [
    // 🔹 Numbering row
    {
      key: "header",
      col1: "1",
      col2: "2",
      col3: "3",
      col4: "4",
      isNumberRow: true,
    },

    // 🔹 Unregistered Persons
    {
      key: "u_title",
      col1: "Supplies made to Unregistered Persons",
      isSectionHeader: true,
    },
    {
      key: "u_row",
      col1: empty,
      col2: empty,
      col3: empty,
      col4: empty,
    },

    // 🔹 Composition Persons
    {
      key: "c_title",
      col1: "Supplies made to Composition Taxable Persons",
      isSectionHeader: true,
    },
    {
      key: "c_row",
      col1: empty,
      col2: empty,
      col3: empty,
      col4: empty,
    },

    // 🔹 UIN
    {
      key: "uin_title",
      col1: "Supplies made to UIN holders",
      isSectionHeader: true,
    },
    {
      key: "uin_msg",
      col1: "We are not tracking supplies made to UIN holders",
      isMessageRow: true,
    },
  ];

  const columns = [
    {
      title: "",
      dataIndex: "col1",
      width: "30%",
      render: (value, record) => {
        if (record.isSectionHeader) {
          return {
            children: (
              <div style={{ padding: "10px 0", fontWeight: 500 }}>
                {value}
              </div>
            ),
            props: {
              colSpan: 4,
              style: { background: "#fafafa" },
            },
          };
        }

        if (record.isMessageRow) {
          return {
            children: (
              <div
                style={{
                  textAlign: "center",
                  color: "#666",
                  fontStyle: "italic",
                  padding: "10px 0",
                }}
              >
                {value}
              </div>
            ),
            props: { colSpan: 4 },
          };
        }

        return value;
      },
      onCell: (record) => {
        if (record.isSectionHeader || record.isMessageRow) {
          return { colSpan: 4 };
        }
        return {};
      },
    },

    {
      title: "PLACE OF SUPPLY",
      dataIndex: "col2",
      align: "center",
      width: "25%",
      render: (value, record) => {
        if (record.isSectionHeader || record.isMessageRow) return null;
        return value;
      },
      onCell: (record) => {
        if (record.isSectionHeader || record.isMessageRow) {
          return { colSpan: 0 };
        }
        return {};
      },
    },

    {
      title: "TAXABLE VALUE",
      dataIndex: "col3",
      align: "center",
      width: "25%",
      render: (value, record) => {
        if (record.isSectionHeader || record.isMessageRow) return null;
        return value;
      },
      onCell: (record) => {
        if (record.isSectionHeader || record.isMessageRow) {
          return { colSpan: 0 };
        }
        return {};
      },
    },

    {
      title: "INTEGRATED TAX",
      dataIndex: "col4",
      align: "center",
      width: "20%",
      render: (value, record) => {
        if (record.isSectionHeader || record.isMessageRow) return null;
        return value;
      },
      onCell: (record) => {
        if (record.isSectionHeader || record.isMessageRow) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
  ];

  return (
    <>
      <Title level={5}>
        3.2 Of the supplies shown in 3.1 (a) above, details of inter-State
        supplies made to unregistered persons, composition taxable persons and
        UIN holders
      </Title>

      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        rowKey="key"
        scroll={printMode ? undefined : { x: "max-content" }}
      />
    </>
  );
};

export default Section3_2;